/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { injectIntl } from 'react-intl'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import {
  Input,
  Modal,
  Form,
  Button,
  Avatar,
  Image,
  Select,
  message,
} from 'antd'
import IntlTranslate from '../../util/IntlTranslate'
import {
  getAvatarUser,
  getProfileUser,
  updateSysUser,
} from '../../appRedux/actions'
import { nameValidator } from '../../util/nameValidator'
import { SystemUsersApi } from '../../client-axios/api'
import { axiosInstance } from '../../core/axios'
import { configHeader } from '../../core/token'
import {
  STATUS_CODE_SUCCESS,
  STATUS_CODE_UPDATE_SUCCESS,
} from '../../constants/StatusCode'
import { EditOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { CountryCode, regionNames } from '../../constants/CountryCode'
import { Permission } from '../../constants/Permission'
import UploadAvatar from '../ComponentCommon/UploadAvatar'
import Upload, { RcFile, UploadProps } from 'antd/lib/upload'
import DraggableEvent from 'react-draggable'
import Draggable, { DraggableData } from 'react-draggable'
const sysUser = new SystemUsersApi(configHeader(), undefined, axiosInstance)
const MyProfile = (props: any) => {
  const { SysUserRecord } = useSelector(
    (state: RootStateOrAny) => state.sysUser
  )
  const sysUserRecordRef = useRef(SysUserRecord)
  sysUserRecordRef.current = SysUserRecord
  const { intl, visibleModal, onCloseModal } = props
  const t = IntlTranslate(intl)
  const [isLocked, setLocked] = useState(false)
  const [isEdit, setEditValue] = useState(false)
  const [avatar, setAvatar] = useState<any | undefined>()
  const [loadings, setLoadings] = useState(false)
  const [locations, setLocations] = useState<
    { label: string; value: string }[]
  >([])
  const [form] = Form.useForm()
  const dispatch = useDispatch()
  const [imageUrl, setImageUrl] = useState<string>()
  const [loading, setLoading] = useState(false)
  const [infoImg, setInfoImg] = useState<any>({
    avatarLarge: null,
    avatarMedium: null,
    avatarOriginal: null,
    avatarSmall: null,
  })
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)
  const draggleRef = useRef<HTMLDivElement>(null)
  const mimeType = 'image/png'
  const getBase64 = (img: RcFile, callback: (url: string) => void) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result as string))
    reader.readAsDataURL(img)
  }
  useEffect(() => {
    dispatch(getProfileUser({ sub: localStorage.getItem('username') }))
  }, [dispatch])
  useEffect(() => {
    if (SysUserRecord) {
      sysUser.findOneAvatarWithSysusers(SysUserRecord?.id).then((res) => {
        if (res.status == STATUS_CODE_SUCCESS) {
          setAvatar(res.data)
        }
      })
      dispatch(getAvatarUser({ value: SysUserRecord.id }))
    }
  }, [SysUserRecord, dispatch])
  useEffect(() => {
    const newLocations = CountryCode.map((code) => {
      return {
        value: code,
        label: regionNames(code) || 'N/A',
      }
    })
    setLocations(newLocations)
  }, [])


  useEffect(() => {
    if (!SysUserRecord) {
      setEditValue(false)
      form.resetFields()
      return
    }
    form.setFieldsValue({
      ...SysUserRecord,
    })
  }, [form, SysUserRecord])
  const beforeUpload = async (file: RcFile) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!')
    }
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!')
    }
    const response = await sysUser.uploadedFileWithSysusers(file)
    if (response.status === 201) {
      setInfoImg(response.data)
      getBase64(file as RcFile, (url) => {
        setLoading(false)
        setImageUrl(url)
      })
    } else {
      message.error(`${file.name} file upload failed.`)
    }
    return false
  }
  const layout = {
    labelCol: {
      span: 7,
    },
    wrapperCol: {
      span: 24,
    },
  }
  const closeModal = () => {
    setEditValue(false)
  }
  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement
    const targetRect = draggleRef.current?.getBoundingClientRect()
    if (!targetRect) {
      return
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    })
  }
  const onFinish = async () => {
    const currentRecord = sysUserRecordRef.current
    if (!currentRecord) return
    const values = await form.validateFields()
    if (sysUserRecordRef.current !== currentRecord) return
    setLoadings(true)
    const bodyUpdate = {
      ...values,
      avatarOriginal: infoImg.avatarOriginal,
      avatarSmall: infoImg.avatarSmall,
      avatarMedium: infoImg.avatarMedium,
      avatarLarge: infoImg.avatarLarge,
    }
    const checkCode = await dispatch(
      updateSysUser({
        id: parseInt(currentRecord.id),
        data: bodyUpdate,
      })
    )
    if (checkCode === STATUS_CODE_UPDATE_SUCCESS) {
      message.success(t('notify.update.success'))
      setLoadings(false)
      setEditValue(false)
      onCloseModal()
      dispatch(getProfileUser({ sub: localStorage.getItem('username') }))
    } else {
      setLoadings(false)
    }
  }
  const propsUpload: UploadProps = {
    beforeUpload: beforeUpload,
  }
  const uploadButton = (
    <div>
      {loading ? (
        <LoadingOutlined rev={undefined} />
      ) : (
        <PlusOutlined rev={undefined} />
      )}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  )
  return (
    <Modal
      width={700}
      title={
        <div
          style={{
            width: '100%',
            cursor: 'move',
          }}
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false)
            }
          }}
          onMouseOut={() => {
            setDisabled(true)
          }}
        >
          {t('myProfile.title')}
        </div>
      }
      visible={visibleModal}
      closable={false}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={bounds}
          onStart={(event: any, uiData) => onStart(event, uiData)}
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      footer={[
        <>
          {!isEdit ? (
            <Button type="primary" onClick={onCloseModal} key="save">
              {t('btn.ok')}
            </Button>
          ) : (
            <>
              <Button onClick={closeModal} key="cancel">
                {t('btn.cancel')}
              </Button>
              <Button
                type="primary"
                key="save"
                htmlType="submit"
                disabled={!SysUserRecord}
                onClick={onFinish}
              >
                {t('btn.save')}
              </Button>
            </>
          )}
        </>,
      ]}
    >
      <Form {...layout} form={form}>
        <div className="gx-modal-box-form-item">
          <div className="gx-form-group">
            {!isEdit ? (
              <Form.Item
                name="displayName"
                className="margin-bottom-0"
                label={t('userManagement.userName')}
              >
                <span>{SysUserRecord?.displayName}</span>
              </Form.Item>
            ) : (
              <Form.Item
                name="displayName"
                className="margin-bottom-0"
                label={t('userManagement.userName')}
                rules={[
                  {
                    validator: nameValidator,
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
            )}
          </div>
          <div className="gx-form-group">
            <Form.Item
              name="email"
              className="margin-bottom-0"
              label={t('userManagement.email')}
            >
              <span>{SysUserRecord?.email}</span>
            </Form.Item>
          </div>
          <div className="gx-form-group">
            {!isEdit ? (
              <Form.Item
                name="company"
                className="margin-bottom-0"
                label={t('userManagement.company')}
              >
                <span>{SysUserRecord?.company}</span>
              </Form.Item>
            ) : (
              <Form.Item
                requiredMark={'optional'}
                name="company"
                className="margin-bottom-0"
                label={t('userManagement.company')}
              >
                <Select placeholder={t('userManagement.company')} />
              </Form.Item>
            )}
          </div>
          <div className="gx-form-group">
            {!isEdit ? (
              <Form.Item
                name="location"
                className="margin-bottom-0"
                label={t('userManagement.location')}
              >
                <span>{SysUserRecord?.location}</span>
              </Form.Item>
            ) : (
              <Form.Item
                requiredMark={'optional'}
                name="location"
                className="margin-bottom-0"
                label={t('userManagement.location')}
              >
                <Select allowClear placeholder={t('userManagement.location')}>
                  {locations.map((item) => {
                    return (
                      <Select.Option
                        key={'country' + item.value}
                        value={item.value}
                      >
                        {item.label}
                      </Select.Option>
                    )
                  })}
                </Select>
              </Form.Item>
            )}
          </div>
          <div className="gx-form-group">
            <Form.Item
              name="permissionGroups"
              className="margin-bottom-10"
              label={t('userManagement.permission')}
            >
              <span>{SysUserRecord?.permissionGroups}</span>
            </Form.Item>
          </div>
          <div className="gx-form-group">
            {!isEdit ? (
              <Form.Item
                name="Avatar"
                className="margin-bottom-10"
                label={'Avatar'}
              >
                <Avatar
                  shape="square"
                  size="large"
                  src={
                    SysUserRecord?.avatarLarge ? (
                      <Image
                        src={
                          avatar &&
                          `data:${mimeType};base64,${Buffer.from(
                            avatar.data
                          ).toString('base64')}`
                        }
                        style={{ width: 50 }}
                      />
                    ) : (
                      <Image
                        style={{ width: 50 }}
                        src="error"
                        fallback="data:image/png;base64,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"
                      />
                    )
                  }
                />
              </Form.Item>
            ) : (
              <Form.Item className="margin-bottom-0" label={'Avatar'}>
                <Upload
                  {...propsUpload}
                  name="image"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                >
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{ width: '100%' }}
                    />
                  ) : SysUserRecord?.avatarLarge ? (
                    <img
                      src={
                        avatar &&
                        `data:${mimeType};base64,${Buffer.from(
                          avatar.data
                        ).toString('base64')}`
                      }
                      alt="avatar"
                      style={{ width: '100%' }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Form.Item>
            )}
          </div>
          {!isEdit && (
            <Form.Item>
              <Button
                type="link"
                className="edit-modal-profile"
                disabled={!SysUserRecord}
                onClick={() => setEditValue(true)}
              >
                <EditOutlined aria-hidden="true" className="eye-icon" />
                <span className="mg-left-5 eye-icon">Edit</span>
              </Button>
            </Form.Item>
          )}
        </div>
      </Form>
    </Modal>
  )
}
export default injectIntl(MyProfile)
